























import { Sort } from '@empathy/search-types';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { EVENTS } from '../../../bus/events.const';
import Dropdown from '../dropdown/dropdown.vue';

@Component({
  components: {
    Dropdown
  }
})
export default class SortDropdown extends Vue {
  @Prop({ default: false })
  private expanded: boolean;

  @Prop({ required: true })
  private sorts: Sort[];

  @Prop({ required: true })
  private selectedSort: Sort;

  @Prop({ default: false })
  private expandOnHover: boolean;

  get selectedItemIndex() {
    return this.sorts.findIndex(sort => sort.value === this.selectedSort.value);
  }

  private getSortTitle(sort: Sort) {
    return this.$x.messages.sort.sortTitles[sort.title] || '';
  }

  private expandDropdown() {
    if (!this.expanded) {
      this.$x.emit(EVENTS.SortToggleClicked);
    }
  }

  private collapseDropdown() {
    if (this.expanded) {
      this.$x.emit(EVENTS.SortToggleClicked);
    }
  }

  private emitSortSelected(selectedIndex: number) {
    this.$x.emit(EVENTS.SortClicked, this.sorts[selectedIndex]);
  }
}
